exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row h3[data-v-a834b838] {\n  line-height: 1.2;\n}\n@media (min-width: 1024px) {\n.row h3[data-v-a834b838] {\n    line-height: 48px;\n}\n}", ""]);

// exports
